import { SquareTerminal } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SquareTerminalIcon = createLucideIcon(SquareTerminal);
